import React, { ComponentProps, lazy, Suspense } from 'react';

import { HomepageFullscreenLoader } from '~/src/components/HomepageFullscreenLoader';

const AddToCalendar = lazy(() =>
  import('./AddToCalendar').then(module => ({
    default: module.AddToCalendar,
  })),
);

export const LazyAddToCalendar: React.FC<ComponentProps<typeof AddToCalendar>> = props => {
  return (
    <Suspense fallback={<HomepageFullscreenLoader />}>
      <AddToCalendar {...props} />
    </Suspense>
  );
};
